import { FC } from "react"
import { DefaultMoodIconSize } from "../../utils/constants"
import { MoodIconProps } from "../../utils/types"

const MoodLowestIcon: FC<MoodIconProps> = ({
  x,
  y,
  height = DefaultMoodIconSize,
  width = DefaultMoodIconSize,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      y={y}
      x={x}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.994 4.47963 15.5204 0.00597071 10 0ZM9.99935 18.3317C5.39698 18.3317 1.66602 14.6007 1.66602 9.99837C1.66602 5.396 5.39698 1.66504 9.99935 1.66504C14.6017 1.66504 18.3327 5.396 18.3327 9.99837C18.3276 14.5987 14.5996 18.3267 9.99935 18.3317ZM6.85787 15.0417C6.60639 15.4267 6.09065 15.5352 5.70537 15.2842C5.51935 15.1641 5.38878 14.9749 5.3425 14.7583C5.29622 14.5418 5.33803 14.3157 5.4587 14.1301C6.45787 12.5928 8.16689 11.6653 10.0004 11.6653C11.8338 11.6653 13.5429 12.5928 14.542 14.1301C14.7938 14.5157 14.6852 15.0325 14.2995 15.2842C13.9139 15.536 13.3971 15.4274 13.1454 15.0417C12.4536 13.9779 11.2706 13.3361 10.0016 13.3361C8.7326 13.3361 7.54968 13.9779 6.85787 15.0417ZM7.55106 7.58512L6.32441 6.36378C6.05274 6.09329 6.02813 5.67926 6.26942 5.43901C6.51072 5.19876 6.92655 5.22327 7.19821 5.49376L8.67387 6.96302C8.85021 7.1386 8.92246 7.37465 8.88546 7.5844C8.92295 7.79445 8.85077 8.03108 8.67409 8.207L7.19843 9.67626C6.92677 9.94674 6.51093 9.97126 6.26964 9.73101C6.02834 9.49076 6.05296 9.07672 6.32462 8.80624L7.55106 7.58512ZM11.1138 7.58161C11.0763 7.37156 11.1485 7.13493 11.3252 6.95902L12.8008 5.48975C13.0725 5.21927 13.4883 5.19476 13.7296 5.43501C13.9709 5.67526 13.9463 6.08929 13.6746 6.35978L12.4482 7.5809L13.6749 8.80224C13.9465 9.07272 13.9711 9.48675 13.7298 9.727C13.4885 9.96725 13.0727 9.94274 12.8011 9.67226L11.3254 8.20299C11.1491 8.02742 11.0768 7.79136 11.1138 7.58161Z"
        fill="#424F80"
        fill-opacity="0.7"
      />
    </svg>
  )
}

export default MoodLowestIcon
